































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Lists from './Service/Lists';
import Delete from './Service/Delete';
import Kick from './Service/Kick';
import manageForm from './form';
import advSearch from './advSearch.vue';

@Component({
  components: {
    advSearch,
  },
})
export default class manageLists extends Vue {
  @Prop({
    default() {
      return { width: 0, height: 0 };
    },
  })
  private contentSize!: any;

  private loading: boolean = false; // 讀取中

  private manageForm: Object = manageForm;

  private tableData: Array<Object> = [];

  private selected: Array<Object> = [];

  private dialogCreate: boolean = false;

  private dialogAdvSearch: boolean = false;

  // table選擇的項目
  private handleSelectionChange(val: Array<Object>): void {
    this.selected = val;
  }

  private sortChange(column: any) {
    this.$store.commit('sortChange', column);
  }

  /**
   * setModify 編輯功能
   */
  public setModify(item: any) {
    const guid = item.p3_ant_id;
    this.$router.push(`/account/manage/modify?p3_ant_id=${guid}`);
  }

  /** 取得列表 */
  public async getLists(params?: object) {
    const getter = (await new Lists(params).get()) as any;
    this.tableData = getter.list;
  }

  /** 刪除功能，可複選 */
  public async doDelete(item: any) {
    const doDelete = (await new Delete(item).delete()) as any;
    if (doDelete.data.code === 0) {
      this.selected = [];
      this.getLists();
    }
  }

  /** 踢人功能，可複選 */
  public async doKick(item: any) {
    const doDelete = (await new Kick(item).kick()) as any;
    if (doDelete.data.code === 0) {
    }
  }

  private mounted() {
    /** 從bus偵測新增行為 */
    this.$bus.$on('create', () => {
      this.$router.push('/account/manage/create');
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('delete', () => {
      this.doDelete(this.selected);
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('advSearch', () => {
      this.dialogAdvSearch = true;
    });

    this.getLists();
  }

  beforeRouteUpdate(to: any, from: any, next: Function) {
    next();
    this.getLists();
  }
}
